import { render, staticRenderFns } from "./list.vue?vue&type=template&id=10c7ec55&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7ec55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c7ec55')) {
      api.createRecord('10c7ec55', component.options)
    } else {
      api.reload('10c7ec55', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=10c7ec55&scoped=true", function () {
      api.rerender('10c7ec55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/order-reduce/list.vue"
export default component.exports